'use client';

import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

const useMagicAuthSavedEmail = () => {
	const magicAuthSavedEmail = useSyncLocalStorage('magicAuthSavedEmail', '');

	return magicAuthSavedEmail;
};

export default useMagicAuthSavedEmail;
